import {
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faSquare,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export const CheckboxOrRadio = ({
  role,
  selected,
}: {
  role?: 'checkbox' | 'radio'
  selected?: boolean
}) => (
  <React.Fragment>
    {selected ? (
      <FontAwesomeIcon
        className={`${'text-blue-600'}  text-blue-600 !h-5 !w-5 group-hover:text-white group-focus:text-indigo-600 mr-2`}
        icon={role === 'checkbox' ? faCheckSquare : faCheckCircle}
      />
    ) : (
      <FontAwesomeIcon
        className={`text-white border border-blue-600 ${
          role === 'checkbox' ? 'rounded-sm' : 'rounded-full'
        } !h-4 !w-4 mr-2 `}
        icon={role === 'checkbox' ? faSquare : faCircle}
      />
    )}
  </React.Fragment>
)
